'use strict';

$(function () {
    $('form').on('submit', function(e) {
        const $form = $(this);
        if($form.prop('is-submitted') && !$form.hasClass('doNotBlockSubmit')) {
            e.preventDefault();
            return false;
        }
        if (!$form.find(':invalid').length){
            $form.prop('is-submitted', true);
            $form.find('button:submit').prop('disabled', true);
        }
    })
})
